import { render, staticRenderFns } from "./ReporteListaNegraRedenciones.vue?vue&type=template&id=6b12ed00"
import script from "./ReporteListaNegraRedenciones.vue?vue&type=script&lang=js"
export * from "./ReporteListaNegraRedenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports